import React from "react";
import { Routes, Route } from "react-router-dom";
import { Home } from "./Home";
import { FAQVideo } from "./FAQVideo";
import { Pamphlet } from "./Pamphlet";
import { About } from "./About";
import { Contact } from "./Contact";

export const Main = () => (
  <div className="content">
    <Routes>
      <Route path="/faqvideo" element={<FAQVideo />} />
      <Route path="/pamphlet" element={<Pamphlet />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/" element={<Home />} />
    </Routes>
  </div>
);